import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { BuyComponent } from "./buy/buy.component";
import { SellComponent } from "./sell/sell.component";
import { RentComponent } from "./rent/rent.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { BuildingDetailsComponent } from "./buildings/building-details/building-details.component";
import { BuildingListComponent } from "./buildings/building-list/building-list.component";
import { BuildingItemComponent } from "./buildings/building-list/building-item/building-item.component";
import { DataService } from "./service/buildings.service";
import { HttpClientModule } from "@angular/common/http";
import { AuthService } from "./auth/auth.service";
import { AuthGuard } from "./auth/auth-guard.service";

import { environment } from "../environments/environment";
import { FilterComponent } from "./header/filter/filter.component";
import { UserprofileComponent } from "./auth/userprofile/userprofile.component";
import { AdminComponent } from "./admin/admin/admin.component";
import { Material } from "./material";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { UploadFormComponent } from "./upload/upload-form/upload-form.component";
import { HomeDetailsDialogComponent } from "./home-details-dialog/home-details-dialog.component";
import { MatBottomSheet } from "@angular/material";
import { ImageSliderComponent } from "./image-slider/image-slider.component";
import {
  AppTranslationService,
  TranslateLanguageLoader
} from "./service/app-translation.service";
import { ConfigurationService } from "./service/configuration.service";
import { LocalStoreManager } from "./service/local-store-manager.service";
import { SelectDirective } from "./directives/select.directive";
import { SweetAlert2Module } from "@toverux/ngx-sweetalert2";
import { FileDropDirective } from "./file-drop.directive";
import { AuthorizationComponent } from "./auth/authorization/authorization.component";

@NgModule({
  declarations: [
    FileDropDirective,
    AppComponent,
    HomeComponent,
    BuyComponent,
    SellComponent,
    RentComponent,
    HeaderComponent,
    FooterComponent,
    BuildingDetailsComponent,
    BuildingListComponent,
    BuildingItemComponent,
    SelectDirective,
    FilterComponent,
    UserprofileComponent,
    AdminComponent,
    UploadFormComponent,
    HomeDetailsDialogComponent,
    ImageSliderComponent,
    AuthorizationComponent
  ],
  imports: [
    SweetAlert2Module.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateLanguageLoader
      }
    }),
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,

    BrowserAnimationsModule,
    Material
  ],
  providers: [
    AppTranslationService,
    DataService,
    AuthService,
    AuthGuard,
    HeaderComponent,
    BuyComponent,
    MatBottomSheet,
    ConfigurationService,
    LocalStoreManager
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    HomeDetailsDialogComponent,
    ImageSliderComponent,
    AuthorizationComponent
  ]
})
export class AppModule {}
